module.exports = __webpack_public_path__ + "img/blm.38e27b68.svg";